import { render, staticRenderFns } from "./OperatnUkrainianIcon.vue?vue&type=template&id=0300e8e3&"
import script from "./OperatnUkrainianIcon.vue?vue&type=script&lang=ts&"
export * from "./OperatnUkrainianIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports